import React from 'react';
import { Box, Flex, Tag, Tooltip } from 'pounceV2';
import CircularProgress from '@mui/material/CircularProgress';
import type { Attachment } from './hooks/useAIAttachments';
import { truncateFileName } from './utils/attachmentConstants';

interface AIAttachmentPillsV3Props {
  attachments: Attachment[];
  onRemove: (id: string) => void;
}

const AIAttachmentPillsV3: React.FC<AIAttachmentPillsV3Props> = ({ attachments, onRemove }) => {
  if (attachments.length === 0) {
    return null;
  }

  return (
    <Flex gap={2} flexWrap="wrap">
      {attachments.map(attachment => (
        <Tooltip key={attachment.id} content={attachment.fileName}>
          <Tag
            variant="neutral2"
            onDelete={() => onRemove(attachment.id)}
            disabled={attachment.isUploading}
            sx={{
              '& .MuiSvgIcon-root': { margin: 0 },
              '& .MuiChip-deleteIcon': {
                width: 14,
                height: 14,
                fontSize: 14,
              },
            }}
          >
            <Box mr={2}>
              {attachment.isUploading ? (
                <CircularProgress size={14} />
              ) : (
                truncateFileName(attachment.fileName)
              )}
            </Box>
          </Tag>
        </Tooltip>
      ))}
    </Flex>
  );
};

export default AIAttachmentPillsV3;
